import React,{Component} from "react";
import {observer} from "mobx-react/index";
import styles from './index.css';
import {dcUnitsStore, presets, receptionBunkersStore, shipment, storageStore} from "../../stores";


@observer
export default class GameResults extends Component {

    render() {
        return (
            <div className={styles.equipResult}>
                <h3>Елементи елеватора:</h3>
                <div className={styles.scrollContainer}>
                    <div className={styles.scrollableCheck}>
                        <SelectedEquipment arr={receptionBunkersStore.receptionBunker} title="Лінії приймання"/>
                        <SelectedEquipment arr={dcUnitsStore.cleaningList} title="Обладнання для очистки"/>
                        <SelectedEquipment arr={dcUnitsStore.dryingList} title="Обладнання для сушки"/>
                        <SelectedEquipment arr={storageStore.silosList.concat(storageStore.hoppersList)} title="Потужності зберігання"/>
                        <SelectedEquipment arr={shipment.shipmentBunker} title="Лінії відгрузки"/>
                    </div>
                </div>
            </div>
        );
    }
}

const SelectedEquipment = (props) =>{
    if(props.arr.length){
        let obj = {};
        props.arr.forEach((item)=>{
            if(!obj[item.name]) obj[item.name] = 0;
            obj[item.name]+=1;
        });
        return (
            <div className={styles.equipResultSection}>
                <h4>{props.title}</h4>
                {Object.keys(obj).map((item,i)=>{
                    return(
                        <div className={styles.equipCheckItem} key={i}>
                            <p>{item}</p>
                            <p>{obj[item]}шт</p>
                        </div>
                    )})}
            </div>
        )
    }
    return null;
};


// WEBPACK FOOTER //
// ./src/shared/components/Results/index.js